import React from 'react'
import { Box, useMediaQuery } from '@mui/material'
import { useTheme } from '@emotion/react'
import TalentCalendarToggler from './TalentCalendarToggler'

const TalentCalendarHeader = ({ calendarValue, setCalendarValue, handleClick }) => {
  const theme = useTheme()
  const md = useMediaQuery(theme.breakpoints.up('md'))
  const sm = useMediaQuery(theme.breakpoints.up('sm'))

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        height: 50,
      }}
    >
      <TalentCalendarToggler
        setCalendarValue={setCalendarValue}
        calendarValue={calendarValue}
        handleClick={handleClick}
        md={md}
        sm={sm}
      />
    </Box>
  )
}

export default TalentCalendarHeader
